import React, { Component } from 'react'; // eslint-disable-line no-unused-vars
import { connect } from 'react-redux';
import { compose } from 'redux';
import { func } from 'prop-types';
import { showModal } from '../../../../../actions/runtime';
import { PROFILE_DISCOVER_CARD_TAPPED } from '../../../../../core/analytics/events';
import {
  PATIENT_TYPE_ADULTS,
  PATIENT_TYPE_KIDS,
  TRACKING_CLICK_TILE_IN_THE_ACCOUNT,
} from '../../../../../constants/index';
import { TrackingEntities, TrackingTypes } from '../../../../../constants/dapi/tracking';
import { analyticsTrackEvent } from '../../../../../core/analytics';
import { profileIsChild } from '../../../../../core/util/account';
import { isEmptyObject } from '../../../../../core/util/object';
import { apiPostJson } from '../../../../../core/dapi';
import { getTrackingUrl } from '../../../../../core/dapi/tracking';
import { TileAction } from './tileEnums';
import history from '../../../../../core/history';
import { ACCOUNT_HOME_URL_PART, GET_CARE_LOCATION_LIST } from '../../../../Account/util/views';
import { createLocationUrlFromLocation } from '../../../../../core/url/location';
import { RemixRoutes } from '~/core/remix';
import { transformPatientType } from '~/routes/search/remixSrp';

function withTileAction(ComposedComponent: any) {
  return class WithTileAction extends Component {
    static propTypes = {
      triggerModal: func,
    };

    doTileAction = (
      tileIndex: any,
      tile: any,
      userProfile: any,
      location: any,
      eventName = PROFILE_DISCOVER_CARD_TAPPED
    ) => {
      analyticsTrackEvent(eventName, {
        category: tile.categoryTitle,
        categoryId: tile.categoryId,
        title: tile.title,
        tileId: tile.id,
        card_index: tileIndex,
      });

      const { providerType } = tile;
      const patientType = profileIsChild(userProfile) ? PATIENT_TYPE_KIDS : PATIENT_TYPE_ADULTS;

      // SOLV-4102: Record Which Users Click Which Cards, so we can email these users
      !isEmptyObject(userProfile) &&
        apiPostJson(
          getTrackingUrl(
            TrackingEntities.USER_PROFILES,
            userProfile.user_profile_id,
            TrackingTypes.CLICK_TILE
          ),
          {
            type: TRACKING_CLICK_TILE_IN_THE_ACCOUNT,
            category: tile.categoryTitle,
            categoryId: tile.categoryId,
            title: tile.title,
            tileId: tile.id,
            card_index: tileIndex,
          }
        );

      switch (tile.action) {
        case TileAction.RECENT_PEDIATRIC:
        case TileAction.RECENT_URGENT_CARE: {
          if (location) {
            const url = createLocationUrlFromLocation(location);
            history.push(url);
          } else {
            history.push('/');
          }

          break;
        }

        case TileAction.BOOKING_FORM:
        case TileAction.COMING_SOON: {
          const query = location ? `?l=${location.id}` : '';
          history.push(
            `/account/people/${userProfile.user_profile_id}/${ACCOUNT_HOME_URL_PART}/${tile.categoryId}/${tile.id}${query}`
          );
          break;
        }

        case TileAction.LINK:
          typeof tile.link === 'function'
            ? tile.link({ userProfile })
            : window.open(tile.link, '_blank');
          break;

        case TileAction.LOCATION_LIST:
          history.push(
            `/account/people/${userProfile.user_profile_id}/${ACCOUNT_HOME_URL_PART}/${GET_CARE_LOCATION_LIST}`
          );
          break;

        case TileAction.SRP:
          window.location.href = RemixRoutes.search.controlled({
            patient: transformPatientType(patientType),
          });
          break;

        case TileAction.CDP:
          history.push(createLocationUrlFromLocation(location));
          break;

        case TileAction.OPEN_MODAL:
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'triggerModal' does not exist on type 'Re... Remove this comment to see the full error message
          this.props.triggerModal(tile.modalId, tile.modalValue);
          break;

        case TileAction.INSURANCE_TAB:
          history.push(`/account/home/${userProfile.user_profile_id}/insurance`);
          break;

        case TileAction.FIND_CARE_TAB:
          history.push(`/account/home/${userProfile.user_profile_id}/get-care`);
          break;

        default:
          break;
      }
    };

    render() {
      return <ComposedComponent {...this.props} doTileAction={this.doTileAction} />;
    }
  };
}

const mapDispatchToProps = (dispatch: any) => ({
  triggerModal: (modalId: any, value: any) => dispatch(showModal(modalId, value)),
});

// https://medium.com/practo-engineering/connected-higher-order-component-hoc-93ee63c91526
const composedWithTileAction = compose(connect(null, mapDispatchToProps), withTileAction);

export default composedWithTileAction;
